var _circle, _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_204_2431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_204_2431)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_204_2431)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 41.0363C66.9667 41.0363 69.8668 41.9224 72.3336 43.5826C74.8003 45.2428 76.7229 47.6025 77.8582 50.3633C78.9935 53.1241 79.2906 56.162 78.7118 59.0928C78.133 62.0237 76.7044 64.7158 74.6066 66.8288C72.5088 68.9419 69.8361 70.3808 66.9264 70.9638C64.0166 71.5468 61.0006 71.2476 58.2598 70.104C55.5189 68.9605 53.1762 67.0239 51.528 64.5393C49.8797 62.0546 49 59.1335 49 56.1452C49 52.1381 50.5804 48.2951 53.3934 45.4616C56.2065 42.6281 60.0218 41.0363 64 41.0363ZM64 38.5182C60.5388 38.5182 57.1554 39.552 54.2775 41.4889C51.3997 43.4257 49.1566 46.1787 47.8321 49.3996C46.5076 52.6206 46.161 56.1648 46.8363 59.5841C47.5115 63.0034 49.1782 66.1443 51.6256 68.6094C54.0731 71.0746 57.1913 72.7534 60.5859 73.4336C63.9806 74.1137 67.4993 73.7647 70.697 72.4305C73.8947 71.0964 76.6278 68.8371 78.5507 65.9383C80.4736 63.0395 81.5 59.6315 81.5 56.1452C81.5 51.4702 79.6563 46.9867 76.3744 43.681C73.0925 40.3753 68.6413 38.5182 64 38.5182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.75 49.107L70.9875 47.3317L65.6125 52.7457C64.9127 52.4091 64.1266 52.2993 63.3623 52.4313C62.5979 52.5634 61.8931 52.9309 61.3447 53.4833C60.7964 54.0356 60.4315 54.7456 60.3004 55.5154C60.1693 56.2853 60.2783 57.0772 60.6125 57.782L55.25 63.1835L57.0125 64.9588L62.3875 59.5447C63.0873 59.8814 63.8734 59.9912 64.6377 59.8591C65.4021 59.727 66.1069 59.3595 66.6553 58.8072C67.2036 58.2549 67.5685 57.5449 67.6996 56.775C67.8307 56.0052 67.7217 55.2133 67.3875 54.5084L72.75 49.107ZM65.25 56.1452C65.25 56.3943 65.1767 56.6377 65.0393 56.8447C64.902 57.0518 64.7068 57.2132 64.4784 57.3085C64.2499 57.4038 63.9986 57.4287 63.7561 57.3801C63.5137 57.3315 63.2909 57.2116 63.1161 57.0355C62.9413 56.8594 62.8222 56.6351 62.774 56.3909C62.7258 56.1466 62.7505 55.8935 62.8452 55.6634C62.9398 55.4333 63.1 55.2367 63.3055 55.0983C63.5111 54.96 63.7528 54.8862 64 54.8862C64.3315 54.8862 64.6495 55.0188 64.8839 55.2549C65.1183 55.4911 65.25 55.8113 65.25 56.1452Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47.3317C65.0355 47.3317 65.875 46.4861 65.875 45.4431C65.875 44.4 65.0355 43.5544 64 43.5544C62.9645 43.5544 62.125 44.4 62.125 45.4431C62.125 46.4861 62.9645 47.3317 64 47.3317Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_204_2431",
    x: -5,
    y: -6,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_204_2431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_204_2431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_2431",
    x1: -9.17563,
    y1: -50.6818,
    x2: 61.8865,
    y2: -37.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_2431",
    x1: 106.029,
    y1: 68.5515,
    x2: 40.0421,
    y2: 63.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3);
export default __webpack_public_path__ + "static/media/Phase 3.8b44088dace893eeb86d9275fcf1454c.svg";
export { ForwardRef as ReactComponent };